import { IRpcContext } from '../../context/RpcContext';

let globalRpcClient: IRpcContext | null = null;

export function setRpcClient(client: IRpcContext) {
  globalRpcClient = client;
}

export function getRpcClient(): IRpcContext {
  if (!globalRpcClient) {
    throw new Error('RPC Client не инициализирован');
  }
  return globalRpcClient;
}

export class RpcClient {
  static call(method: string, params?: any) {
    const client = getRpcClient();
    return client.callRpcMethod(method, params);
  }
}
